export default "__VITE_ASSET__B6dD5r40__"